var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"my-2 ml-3",attrs:{"variant":"outline-primary"},on:{"click":_vm.showModal}},[_c('b-icon',{attrs:{"icon":"pencil-square"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }